import VinInput from "./VinInput";

// eslint-disable-next-line import/prefer-default-export
export { VinInput };
